import { LOCATION_CHANGE } from "react-router-redux";
import { SELECT_FILTER_OPTION } from "./containers/Catalog/actions";
import { createMiddleware } from "redux-beacon";
import GoogleTagManager from "@redux-beacon/google-tag-manager";
import GoogleAnalytics, {
  trackPageView,
  trackEvent
} from "@masonite/redux-beacon-google-analytics";

const gtm = GoogleTagManager();
const ga = GoogleAnalytics();

const eventsMap = {
  [LOCATION_CHANGE]: trackPageView(
    action => ({
      hitType: "pageview",
      page: action.payload.location.pathname
    }),
    ["masonite"]
  ),
  [SELECT_FILTER_OPTION]: trackEvent(
    action => ({
      category: "RPSv2 Catalog Filter Selections",
      action: "click",
      label: `${action.payload.filter.label}/${action.payload.option.value}`,
      value: Number(action.payload.option.selected)
    }),
    ["masonite"]
  )
};

export const gaMiddleware = createMiddleware(eventsMap, ga);
export const gtmMiddleware = createMiddleware(eventsMap, gtm);
